var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47467 6.08635C9.12327 6.08635 8.95105 6.20368 8.95105 6.34845V8.17571C8.95054 8.60971 8.59885 8.96149 8.16475 8.96201H1.8105C1.3764 8.96149 1.02471 8.60971 1.0242 8.17571V2.34565C1.02471 1.91155 1.3764 1.55987 1.8105 1.55936H3.63766C3.78243 1.55936 3.89976 1.24951 3.89976 0.999512C3.89976 0.749512 3.78243 0.535156 3.63766 0.535156H1.3105C0.587062 0.535975 0.000819062 1.12222 0 1.84565V8.67571C0.000819062 9.39914 0.587062 9.98539 1.3105 9.98621H8.66475C9.38819 9.98539 9.97443 9.39914 9.97525 8.67571V6.34855C9.97525 6.20378 9.82607 6.08635 9.47467 6.08635Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 5.50554L7.27496 1.40039L8.59886 2.72429L4.49383 6.82944L3.16992 5.50554Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.50016L3.96305 7.09491L2.90524 6.03711L2.5 7.50016Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96404 0.705504C8.68938 0.431499 8.24471 0.431499 7.97004 0.705504L7.67188 1.00367L8.99578 2.32757L9.29395 2.02941C9.56806 1.75474 9.56806 1.31007 9.29395 1.03541L8.96404 0.705504Z",
    fill: "#364863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c5faa8a780f86e3e7dead75c38e94d67.svg";
export { ForwardRef as ReactComponent };